/* eslint-disable react/no-array-index-key */

import React, { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { useWindowSize } from 'react-use'

import { PopularVenues } from '@kolayyolla/common/services/venueService'

import { Card, CardMedia, Chip, Container, Grid, Stack, Typography } from '@mui/material'
import { yellow } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    height: 320,
    position: 'relative',
    margin: theme.spacing(3),
    borderRadius: '0.6rem'

  },
  container: {
    margin: theme.spacing(3, 0, 3, 0)
  },

  header: {
    fontWeight: 'bold',
    margin: theme.spacing(2, 0, 4, 0)
  },

  column: {
    minHeight: 300,
    height: '100%'
  },
  media: {

    overflow: 'hidden',
    transition: '300ms',
    cursor: 'pointer',
    borderRadius: '1rem',
    width: '100%',
    height: '100%',
    maxHeight: 200,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
    // boxShadow: '0px 10px 13px -7px #000000, 0px 0px 15px 5px rgba(0,0,0,0)',

    // '&:hover': {
    //   filter: 'brightness(115%)',
    //   transform: 'scale(1.05)'
    // }
  },

  layer: {
    height: '100%',
    width: '100%',
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0.05) 85%)'

  },

  mediaCaption: {
    textOverflow: 'ellipsis',
    bottom: 0,
    padding: theme.spacing(1, 2, 1, 1),
    color: 'black',
    width: '100%',
    fontSize: 15,
    fontWeight: 500,
    transition: '300ms',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      height: 100
    },

    '& .logo': {
      borderRadius: '50%',
      width: theme.spacing(8),
      height: theme.spacing(8),
      marginRight: theme.spacing(1),
      filter: 'drop-shadow(0px 0px 2px rgba(0,0,0,0.5))'
    }

  },

  firstOrderChip: {
    backgroundColor: yellow[800],
    color: theme.palette.getContrastText(yellow[800]),
    fontWeight: 'bold'
  },
  secondOrderChip: {
    backgroundColor: yellow[600],
    color: theme.palette.getContrastText(yellow[600]),
    fontWeight: 'bold'
  },

  bannerGrid:
  {
    height: '100%',
    position: 'relative'

  }

}))

const PopularVenuesBanner = () => {
  const classes                = useStyles()
  const [items, setItems]      = useState([])
  const [venues, setVenues]    = useState([])
  const { width: windowWidth } = useWindowSize()

  useEffect(() => {
    let isMounted = true

    PopularVenues({ limit: 8 }).then((data) => {
      if (isMounted) {
        setVenues(data)
      }
    })

    return () => {
      isMounted = false
    }
  }, [venues.length])

  useEffect(() => {
    if (venues.length > 1) setItems(chunk(venues, windowWidth > 1200 ? 4 : windowWidth > 900 ? 3 : windowWidth > 6500 ? 2 : 1))
  }, [windowWidth, venues])

  const chunk = (arr, size) => Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size))

  return (
    <Container>
      <Typography variant="h3" align="center" className={classes.header}>En Gözde Mekanlar</Typography>

      {
        items.map((row, index) => {
          return <Banner row={row} key={index} />
        })
      }

    </Container>
  )
}

function Banner ({ row }) {
  const classes  = useStyles()
  const navigate = useNavigate()

  const items = row.map((item) => (<Grid item xs={12 / row.length} key={item.resId} className={classes.column}><CardMedia
      className={classes.media}
      image={item?.heroImage?.lg}
      onClick={() => navigate(`/${item.alias}`)}
    >
      <Stack direction="row" spacing={1} mt={1} ml={1}>
        <Chip className={classes.firstOrderChip}  label={`Hoşgeldin %${item.loyalty.settings.firstVisitRate}`}  />
        <Chip className={classes.secondOrderChip} label={`Biriktiren %${item.loyalty.settings.rateRange[0]}`} />
      </Stack>

    </CardMedia>

    {/* <div className={classes.layer} /> */}
    <div className={classes.mediaCaption}>
      <img alt={item.name} src={item?.logo?.md} className="logo" />

      <Stack>
        <Typography >
          <strong>{item.name}</strong>
        </Typography>
        <Typography >
          {`${item?.areaDetails?.district.replace(' Mahallesi', '')}`}
        </Typography>
        </Stack>
    </div>

  </Grid>
  ))

  return (
    <Card raised className={classes.root} elevation={0}>
      <Grid container spacing={2} className={classes.bannerGrid}>
        {items}
      </Grid>
    </Card>
  )
}

export default PopularVenuesBanner
